// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f6d5f974","455":"d881bfe8","977":"6094e6d8"}[chunkId] + ".chunk.js";
};